import { render, staticRenderFns } from "./AdvertisingDetail.vue?vue&type=template&id=9ed7af1c&scoped=true&"
import script from "./AdvertisingDetail.vue?vue&type=script&lang=js&"
export * from "./AdvertisingDetail.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisingDetail.vue?vue&type=style&index=0&id=9ed7af1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed7af1c",
  null
  
)

export default component.exports